import React, { Component } from "react";

import { Dialog } from "primereact/dialog";
import { PaymentStatus, TransactionReportDetails } from "../../models/Transactions";
import moment from "moment";
import { AppCard } from "../../components/ui";

interface ReturnTransactionDetailsProps {
    onHide: () => void;
    transaction: TransactionReportDetails | null;
}

export default class ReturnTransactionDetailsDialog extends Component<ReturnTransactionDetailsProps, Record<string, never>> {
    constructor(props: ReturnTransactionDetailsProps | Readonly<ReturnTransactionDetailsProps>) {
        super(props);

        this.state = {};
    }

    render() {
        if (!this.props.transaction) {
            return null;
        }

        return (
            <Dialog
                header={this.props.transaction.rejectedTransctionStatus ? "Rejected Transaction Details" : "Return Transaction Details"}
                visible={true}
                style={{ width: "70vw" }}
                onHide={this.props.onHide}
            >
                <div className="space-y-4">
                    <AppCard><AppCard.Body>
                        {renderDualRow(
                            "Transaction Id",
                            this.props.transaction.transactionId,

                            "Type",
                            // TransactionType[this.props.transaction.type],
                            this.props.transaction.transactionType,
                        )}
                        {renderDualRow(
                            "Timestamp",
                            moment.utc(this.props.transaction.timeStamp).local().format("DD/MM/YYYY HH:mm:ss"),

                            "Amount",
                            this.props.transaction.amount,
                        )}
                        {renderDualRow(
                            "Transaction Fee",
                            this.props.transaction.transactionFee,

                            "Currency",
                            this.props.transaction.currency,
                        )}
                        {renderDualRow(
                            "Status",
                            this.props.transaction.transactionStatus
                                ? this.props.transaction.transactionStatus
                                : this.props.transaction.transactionCategory
                                  ? this.props.transaction.transactionCategory
                                  : PaymentStatus[0],
                            "Transaction Category",
                            this.props.transaction.transactionCategory,
                        )}

                        {this.props.transaction.errorCodeRejectedTransction &&
                            renderDualRow(
                                "Error Code",
                                this.props.transaction.errorCodeRejectedTransction,

                                "Error Description",
                                this.props.transaction.errorCodeDescriptionRejectedTrans,
                            )}
                    </AppCard.Body></AppCard>

                    <AppCard><AppCard.Header title="Sender Info" /><AppCard.Body>
                        {renderDualRow(
                            "Name",
                            this.props.transaction.senderName,

                            "Merchant",
                            this.props.transaction.merchant,
                        )}
                        {renderDualRow(
                            "Source",
                            this.props.transaction.senderIban,

                            "Payment Notes",
                            this.props.transaction.paymentNotes,
                        )}
                    </AppCard.Body></AppCard>

                    <AppCard><AppCard.Header title="Recepient Info" /><AppCard.Body>
                        {renderDualRow(
                            // "User",
                            // this.props.transaction.receiverEmail,

                            "Name",
                            this.props.transaction.receiverName,
                        )}
                        {renderDualRow("Destination", this.props.transaction.receiverIban)}
                    </AppCard.Body></AppCard>
                </div>

                <div className="mt-4">
                    <AppCard><AppCard.Header title="Return Transaction Details" /><AppCard.Body>
                        <pre>
                            <code>{this.props.transaction ? JSON.stringify(this.props.transaction, null, 2) : ""}</code>
                        </pre>
                    </AppCard.Body></AppCard>
                </div>
            </Dialog>
        );
    }
}

export function renderDualRow(
    title1: string,
    val1: string | number,

    title2: string | null = null,
    val2: string | number = null as any,

    link?: boolean,
    linkFun?: () => void,
) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-1">
            <div className="grid grid-cols-2 gap-2 items-center">
                <span className="text-sm font-bold text-neutral-700 dark:text-neutral-300">
                    {title1} :
                </span>
                <div>
                    {link ? (
                        <a
                            href="#"
                            className="text-blue-600 underline"
                            onClick={(e) => {
                                e.preventDefault();
                                linkFun!();
                            }}
                        >
                            {val1}
                        </a>
                    ) : (
                        <span className="text-sm text-neutral-600 dark:text-neutral-400">{val1}</span>
                    )}
                </div>
            </div>
            {title2 != null && (
                <div className="grid grid-cols-2 gap-2 items-center">
                    <span className="text-sm font-bold text-neutral-700 dark:text-neutral-300">
                        {title2} :
                    </span>
                    <div>
                        <span className="text-sm text-neutral-600 dark:text-neutral-400">{val2}</span>
                    </div>
                </div>
            )}
        </div>
    );
}
